import React, { useEffect, useState } from "react";

// project-import
import { showToast } from "../sweet-alert/Sweetalert";

// third-party
import { useSelector } from "react-redux";

function StarRating({ data }) {

  // State variable
  const [starRatings, setStarRatings] = useState(0);

  // Reading data from store
  const coursesData = (
    useSelector((data) => data.courses.courseUserReactionsCount) || []
  ).filter((item) => item.courseId === data.id);

  // Local variable
  // calculating the percentage ratio of starRating
  let ratings = Number((starRatings - Math.floor(starRatings)) * 100).toFixed(
    2
  );

  // Constant variables
  const courseUserReactionsCount =
    coursesData && coursesData.length
      ? coursesData[0].courseUserReactionsCount
      : null;
  // Dynamic Css for star Rating Start
  const halfIconDynamicStyle = {
    "--width": `${ratings}%`,
    "--rating-percent": `${100 - ratings}%`,
  };
  // Dynamic Css for star Rating End

  useEffect(() => {
    try {
      setStarRatings(calculateStarRatings(courseUserReactionsCount));
    } catch (error) {
      console.log("41:: Error calculating star ratings:", error);
      setStarRatings(0);
      showToast("error", "Error calculating star ratings. Please try again.", true, "bottom-right", false, true, 5000);
    }
  }, [courseUserReactionsCount]);

  // Constant function
  const calculateStarRatings = (reactionsParam) => {
    try {
      let total = 0;
      let positive = 0;
      (reactionsParam && reactionsParam.length ? reactionsParam : []).forEach(
        (item) => {
          total += item["count"];
          if (item["type"] === "positive") {
            positive += item["count"];
          }
        }
      );
      let newTotal = Number(
        Number(((positive / total) * 100).toFixed(2)) / (100 / 5)
      ).toFixed(2);
      return Number(newTotal).toFixed(2);
    } catch (error) {
      console.log(
        "StarRating::::calculateStarRatings::::28::::error::::",
        error && JSON.stringify(error && error.message)
      );
      showToast("error", "Unable to calculate ratings. Please try again later. ", true, "bottom-right", false, true, 5000);
    }
  };

  return (
    <div>
      <div className="rating eduvibe-course-rating-stars">
        {[...Array(5)].map((item, index) => {
          const givenRating = index + 1;
          return (
            <i
              key={index}
              className={
                starRatings >= givenRating
                  ? "icon-Star"
                  : starRatings > givenRating - 1 && starRatings < givenRating
                    ? " icon-Star-half "
                    : " off icon-Star"
              }
              style={halfIconDynamicStyle}
            ></i>
          );
        })}
      </div>
      <span className="rating-count fs-5 text overflow-hidden">
        ({starRatings > 0 ? starRatings + " Avg. Ratings" : "0 Rating"})
      </span>
    </div>
  );
}

export default StarRating;
